export default __webpack_public_path__ + "static/media/p46.a66fcf49.jpg";